import type { LocalizedString } from 'typesafe-i18n';

/**
 * Type-safe branded string type for translations.
 *
 * Uses typesafe-i18n's LocalizedString as the base type, ensuring compatibility
 * with the LL translation functions.
 *
 * This is a "branded" string type that:
 * - Is assignable to regular string properties (backward compatible)
 * - Can be distinguished from regular strings by TypeScript's type system
 * - Has zero runtime overhead (it's just a string at runtime)
 */
export type TranslatedString = LocalizedString;

/**
 * Marks a string as intentionally untranslated.
 * Use sparingly - only for debug/test content or dynamic content that can't be translated.
 *
 * @param value The untranslated string
 * @returns A TranslatedString (branded string)
 */
export function untranslatedString(value: string): TranslatedString {
  return value as TranslatedString;
}

